import { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import loadable from '@utils/loadable';

import { getBrowserScrollTop } from '../../helpers/commonHelpers';
import withMetatag from '../../decorators/metadataDecorators/metatagsTitleDecorator';

import { ARTICLES } from '../../data/EAPItermsArticles';
import { DESKTOP, MOBILE, TABLET } from '../../data/screenSizes';
import withComponentName from '../../decorators/withComponentName';

import Styles from './styles.module.scss';

const ArticlesTitles = loadable(() => import('../ArticlesComponents/ArticlesTitles'));
const ArticleWrapper = loadable(() => import('../ArticlesComponents/ArticleWrapper'));

const cx = classNames.bind(Styles);

export class EAPITerms extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      activeArticle: Object.keys(ARTICLES)[0],
      footerHeight: 0,
      mode: DESKTOP,
    };
    this.timeout = 0;
  }

  componentDidMount() {
    if (window.location.hash && window.location.hash.length > 1) {
      this.switchActiveArticle();
    }
    window.addEventListener('hashchange', this.switchActiveArticle, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    this.timeout = setTimeout(() => {
      this.footer = document.getElementById('common-footer');
      this.onResize();
    }, 1);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.switchActiveArticle);
    window.removeEventListener('resize', this.onResize);
    clearTimeout(this.timeout);
  }

  onResize() {
    let mode;
    switch (true) {
      case window.innerWidth >= 1024:
        mode = DESKTOP;
        break;
      case window.innerWidth >= 768:
        mode = TABLET;
        break;
      default:
        mode = MOBILE;
        break;
    }

    this.setState({
      mode,
      footerHeight: this.footer?.offsetHeight || 0,
    });
  }

  setRef(el) {
    this.terms = el;
  }

  switchActiveArticle() {
    const { promobarHeight } = this.props;

    if (promobarHeight > 0) {
      window.scrollTo(0, getBrowserScrollTop() - promobarHeight);
    }

    this.setState({
      activeArticle: window.location.hash.slice(1),
    });
  }

  render() {
    const { activeArticle, footerHeight, mode } = this.state;

    return (
      <main ref={this.setRef} className={cx('terms', 'clearfix')}>
        <ArticlesTitles
          activeArticle={activeArticle}
          footerHeight={footerHeight}
          mode={mode}
          articles={ARTICLES}
        />
        <section className={cx('articles')}>
          {Object.entries(ARTICLES).map(([id, article]) => (
            <ArticleWrapper key={id} id={id} {...article} />
          ))}
        </section>
      </main>
    );
  }
}

function mapToStateProps({ promobar }) {
  return {
    promobarHeight: promobar.height,
  };
}

export default withComponentName(connect(mapToStateProps, null)(withMetatag(EAPITerms, 'eapi_terms')));
